/*  Mobile – Skip "Collections" menu and show real filters immediately
   - When the mobile filter drawer (#filter-drawer) opens, click every element
     whose text is "Collections" (case-insensitive), then expand the first facet.
   - Retries for a short time in case the drawer DOM renders lazily.
*/
(function () {
  if (window.__filterSkipMenu) return;
  window.__filterSkipMenu = true;

  const OPENERS = [
    '.facets__open', '.collection-filters__toggle', 'button[name="filter"]',
    '.js-mobile-filters-open', '.mobile-facets__open',
    'button[data-drawer-id*="filter"]', '#filter-button', '[data-open-filter]'
  ].join(',');

  function getDrawer() { return document.querySelector('#filter-drawer'); }

  function clickAllCollections(d) {
    const nodes = [...d.querySelectorAll('*')].filter(el =>
      /^\s*collections\s*$/i.test((el.textContent || '').replace(/\s+/g,' ').trim())
    );
    nodes.forEach(el => {
      ['touchstart','touchend','pointerdown','pointerup','mousedown','mouseup','click'].forEach(type => {
        try { el.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true })); } catch (_) {}
      });
      try { el.click && el.click(); } catch (_) {}
    });
    return nodes.length > 0;
  }

  function expandFirstFacet(d) {
    const det = d.querySelector('details');
    if (det && !det.open) det.open = true;
  }

  function drive() {
    const d = getDrawer();
    if (!d) return;

    const t0 = Date.now();
    const end = t0 + 3000; // up to 3s retries (covers lazy render)
    const iv = setInterval(() => {
      if (!document.body.contains(d)) { clearInterval(iv); return; }

      const clicked = clickAllCollections(d);
      if (clicked) {
        setTimeout(() => { expandFirstFacet(d); d.scrollTop = 0; }, 120);
        clearInterval(iv);
        return;
      }

      if (Date.now() > end) clearInterval(iv);
    }, 80);
  }

  // Run after user clicks a known opener
  document.addEventListener('click', (e) => {
    if (e.target && e.target.closest(OPENERS)) {
      setTimeout(drive, 60);
      setTimeout(drive, 250);
      setTimeout(drive, 600);
    }
  }, true);

  // Also watch for programmatic openings
  const mo = new MutationObserver(() => {
    const d = getDrawer();
    if (d && !d.dataset._skipMenuHooked) {
      d.dataset._skipMenuHooked = '1';
      setTimeout(drive, 40);
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
})();
